import React from "react";
import DonutChart from "common-ui-components/components/donut-chart/DonutChart";
import InfoBox from "common-ui-components/components/info-box/InfoBox";

const MissingPatchesBySeverity = ({
  total,
  critical,
  important,
  medium,
  low,
  unrated,
}) => {
  const severity = [
    { id: "Critical", label: "Critical", value: critical, color: "#dc2626" },
    { id: "High", label: "High", value: important, color: "#f79009" },
    { id: "Medium", label: "Medium", value: medium, color: "#2e6be6" },
    { id: "Low", label: "Low", value: low, color: "#8792a2" },
    { id: "Unrated", label: "Unrated", value: unrated, color: "#8b5cf6" },
  ];

  return (
    <InfoBox
      header="Missing Patches by Severity"
      // headerProps={{
      //   style: {
      //     padding: "0",
      //   },
      // }}
      subtitle="Prioritise remediation by severity level"
      badge="All patches"
      style={{ minWidth: 0 }}
    >
      <DonutChart
        data={severity}
        size="15rem"
        thickness={0.2}
        barLegend
        centerText={total}
        centerSubText="missing patches"
        gap="1.5rem"
      />
    </InfoBox>
  );
};

export default MissingPatchesBySeverity;
